import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import AppContext from './context/AppContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AppContext>
    <App />
  </AppContext>
);
